module.exports = __webpack_public_path__ + "static/media/Merriweather-Regular.c97a9fc2.ttf";